import { CSSProperties } from 'react';

import UIConfig from '@/UIConfig.ts';

export const containerStyles: CSSProperties = {
  width: '100%',
  height: '100vh',
  display: 'flex',
  justifyContent: 'center',
  background: UIConfig.Colors.BackgroundWhite
};

export const contentStyles: CSSProperties = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '75%',
  textAlign: 'center',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column'
};

export const contentMessageStyles: CSSProperties = {
  fontSize: '16px',
  color: '#000'
};

export const contentShapeStyles: CSSProperties = {
  marginBottom: '20px'
};

export const buttonShapeStyles: CSSProperties = {
  marginLeft: '10px'
};

export const contentHeaderStyles: CSSProperties = {
  fontSize: '24px',
  fontWeight: 'bold',
  color: '#000'
};

export const buttonStyles = (bottom: string = '30px'): CSSProperties => ({
  position: 'absolute',
  bottom: bottom,
  width: 'calc(100% - 30px)',
  height: '50px',
  color: '#FFF',
  border: 'none',
  borderRadius: '12px',
  background: '#000',
  fontSize: '18px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  outline: 'none',
  textAlign: 'center',
  appearance: 'none',
  fontWeight: 500
});
